// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"85ec67928e0da2da8010","9249":"af9f8111356ff364f850"}[chunkId] + ".chunk.js";
};